export default "__VITE_ASSET__9W_BXvkU__"